import { Brightness4, Brightness7 } from '@material-ui/icons';
import useDarkMode from 'use-dark-mode';

export default function Icon(props) {
  const darkMode = useDarkMode();
  const Component = darkMode.value ? Brightness7 : Brightness4;

  return <Component {...props} />;
}
